$(document).ready(function () {
  $('.modal-trigger').on('click', function (e) {
    e.stopPropagation()
    const selector = '#' + $(this).attr('data-modal-id')

    $(selector).addClass('active')
  })

  $('.modal-box').on('click', function (e) {
    e.stopPropagation()
  })

  $('.modal-close button, .modal').on('click', function () {
    $('.modal').removeClass('active')
  })
})
